import { exactCameraDeviceId } from './exactCameraDeviceId';
import { createLocalTrack as createSharedLocalTrack } from './functions.any';
export * from './functions.any';
/**
 * Web override of the shared createLocalTrack, used by the device pickers'
 * previews. A camera is named exactly: with a bare id every preview showed the
 * browser's own camera rather than the one listed (see exactCameraDeviceId).
 * Microphones keep their bare id here, and native keeps the shared version.
 *
 * @param {string} type - "video" or "audio".
 * @param {string|null} deviceId - The id of the target media source.
 * @param {number} [timeout] - A timeout for the JitsiMeetJS.createLocalTracks function call.
 * @param {Object} additionalOptions - Extra options to be passed to lib-jitsi-meet's {@code createLocalTracks}.
 * @returns {Promise<JitsiLocalTrack>}
 */
export function createLocalTrack(type, deviceId, timeout, additionalOptions) {
    return createSharedLocalTrack(type, deviceId, timeout, type === 'video'
        ? { cameraDeviceId: exactCameraDeviceId(deviceId),
            ...additionalOptions }
        : additionalOptions);
}
/**
 * Loads config.js from a specific remote server.
 *
 * @param {string} _url - The URL to load.
 * @returns {Promise<IConfig>}
 */
export async function loadConfig(_url) {
    // Return "the config.js file" from the global scope - that is how the
    // Web app on both the client and the server was implemented before the
    // React Native app was even conceived.
    return window.config;
}
